import { gtmEvent, filterUndefinedAndEmptyValues } from '../../utils/gtmEvents';
const gtmConfigurationChangeConfirmOrCancel = ({ action, model, trim, gtmBodyStyle, availabilityFlag, }) => {
    const gtmPayload = {
        event: 'trim_configuration_change',
        action: action === 'confirm' ? 'confirm change' : 'cancel change',
        model,
        trim,
        body_style: gtmBodyStyle,
        availability_flag: availabilityFlag,
    };
    const filteredPayload = filterUndefinedAndEmptyValues(gtmPayload);
    gtmEvent(filteredPayload);
};
export default gtmConfigurationChangeConfirmOrCancel;
